import { render, staticRenderFns } from "./tri-check.vue?vue&type=template&id=26932254&"
import script from "./tri-check.vue?vue&type=script&lang=js&"
export * from "./tri-check.vue?vue&type=script&lang=js&"
import style0 from "./tri-check.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports